import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Layout, Box, Text, VerticalSpacing } from '../../components/Boneyard';
import Markdown from '../../components/Markdown';
import { BILLBOARD_DISCLAIMER } from '../../../automationHooks.json';
import { white } from '../../theme/theme/colors';

const propTypes = {
  disclaimerText: PropTypes.string.isRequired,
};

const BillboardDisclaimerText = styled(Text)`
  width: 100%;
  font-size: 0.7rem;
  position: relative;
`;

const BillboardDisclaimer = ({ disclaimerText }) => {
  return (
    <Layout.FullWidth>
      <VerticalSpacing size={5} />
      <Layout.Strip color={white}>
        <Box>
          <BillboardDisclaimerText automationHook={BILLBOARD_DISCLAIMER.hook}>
            <Markdown source={disclaimerText} />
          </BillboardDisclaimerText>
        </Box>
      </Layout.Strip>
      <VerticalSpacing size={5} />
    </Layout.FullWidth>
  );
};

BillboardDisclaimer.propTypes = propTypes;

export default BillboardDisclaimer;
